import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { MENU_ITEMS } from '../constants/navigation';

const Footer: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const servicesItem = MENU_ITEMS.find((item) => item.label === 'Services');

  return (
    <footer className="bg-primary-500 text-secondary-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Social Media */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-secondary-500">
              Follow Us
            </h3>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary-100 hover:text-secondary-500 transition-colors cursor-pointer"
              >
                <span className="sr-only">Facebook</span>
                <Facebook className="h-6 w-6" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary-100 hover:text-secondary-500 transition-colors cursor-pointer"
              >
                <span className="sr-only">Twitter</span>
                <Twitter className="h-6 w-6" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary-100 hover:text-secondary-500 transition-colors cursor-pointer"
              >
                <span className="sr-only">LinkedIn</span>
                <Linkedin className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-secondary-500">
              Quick Links
            </h3>
            <ul className="space-y-2">
              {MENU_ITEMS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href!}
                    className={`text-secondary-100 hover:text-secondary-500 transition-colors cursor-pointer ${
                      item.label === 'Services'
                        ? currentPath === '/services' ||
                          currentPath.startsWith('/services/')
                          ? 'underline text-secondary-500'
                          : ''
                        : currentPath === item.href
                        ? 'underline text-secondary-500'
                        : ''
                    }`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-secondary-500">
              Services
            </h3>
            <ul className="space-y-2">
              {servicesItem?.subItems?.map((subItem) => (
                <li key={subItem.label}>
                  <Link
                    to={subItem.href}
                    className={`text-secondary-100 hover:text-secondary-500 transition-colors cursor-pointer ${
                      currentPath === subItem.href
                        ? 'underline text-secondary-500'
                        : ''
                    }`}
                  >
                    {subItem.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-secondary-500">
              Contact
            </h3>
            <div className="space-y-3 text-sm text-secondary-100">
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-secondary-500 flex-shrink-0" />
                <span>info@harmonyengg.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-secondary-500 flex-shrink-0" />
                <span>+968 97100143/94549531</span>
              </div>
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-secondary-500 flex-shrink-0 mt-0.5" />
                <span>
                  CR NO. 1601293
                  <br />
                  OUHI INDUSTRIAL AREA
                  <br />
                  SOHAR, SULTANATE OF OMAN
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-primary-400">
          <div className="flex justify-center">
            <p className="text-sm text-secondary-100">
              © {new Date().getFullYear()} Harmony Engineering Solutions. All
              rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
